import { useQuery } from "@tanstack/react-query";

import { careplanQueryOptions } from "@/domains/careplan/factories";

export const useCartSellingPlans = (cartVariantIds: string[]) => {
  return useQuery({
    ...careplanQueryOptions.sellingPlans(cartVariantIds),
    enabled: cartVariantIds.length > 0,
  });
};
